import { render, staticRenderFns } from "./PartyTDSCertificate.vue?vue&type=template&id=a16429ca"
import script from "./PartyTDSCertificate.vue?vue&type=script&lang=js"
export * from "./PartyTDSCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports